var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"scrollContainer",staticClass:"home"},[_c('Header',{attrs:{"scrollTop":_vm.scrollTop}}),_c('Home'),_c('Node'),_c('Record'),_c('Share'),_c('FQ'),_c('Foot')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }